import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { map } from "rxjs/operators";
import { BASE_URL } from "../config";

@Injectable({
  providedIn: "root",
})
export class EvolucaoTarifariaService {
  constructor(private http: Http) {}

  getAll() {
    const url = `${BASE_URL}evolucao-tarifaria.php`;
    return this.http.get(url).pipe(map((res) => res.json()));
  }
}
